/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './star_button.css';

import svg_star from 'ikonate/icons/star.svg';
import {makeIcon, MakeIconOptions} from 'neuroglancer/widget/icon';

export function makeStarButton(options: MakeIconOptions = {}) {
  const icon = makeIcon({svg: svg_star, ...options});
  icon.classList.add('neuroglancer-star-icon');
  return icon;
}
